<template>
  <form @submit.prevent="update" id="my-account-personal-information">
    <div class="alert -success" v-if="finished">
      <p>Informações alteradas com sucesso!</p>
    </div>

    <div class="alert -danger" v-if="errors.unrecognized">
      <p>Ocorreu um erro desconhecido ao alterar as informações, por favor tente novamente.</p>
    </div>

    <div class="form-group" :class="{'-has-error': errors.form.email.length > 0}">
      <label for="email" class="label">E-mail</label>
      <input
        type="email"
        id="email"
        name="email"
        class="form-control"
        v-model="form.email"
      >
      <p class="description" v-if="errors.form.email.length > 0">{{ errors.form.email[0] }}</p>
    </div>

    <div class="form-group" :class="{'-has-error': errors.form.name.length > 0}">
      <label for="name" class="label">Nome</label>
      <input
        type="text"
        id="name"
        name="name"
        class="form-control"
        v-model="form.name"
      >
      <p class="description" v-if="errors.form.name.length > 0">{{ errors.form.name[0] }}</p>
    </div>

    <div class="form-group" :class="{'-has-error': errors.form.cpf.length > 0}">
      <label for="cpf" class="label">CPF</label>
      <input
        type="text"
        id="cpf"
        name="cpf"
        class="form-control"
        v-model="form.cpf"
        v-mask="'###.###.###-##'"
        autocomplete
        required
      >
      <p class="description" v-if="errors.form.cpf.length > 0">{{ errors.form.cpf[0] }}</p>
    </div>

    <div class="flex flex-wrap md:flex-no-wrap md:gap-4">
      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{'-has-error': errors.form.phone.length > 0}">
          <label for="phone" class="label">Telefone</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            class="form-control"
            v-model="form.phone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            autocomplete
            required
          >
          <p class="description" v-if="errors.form.phone.length > 0">{{ errors.form.phone[0] }}</p>
        </div>
      </div>

      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{'-has-error': errors.form.birthdate.length > 0}">
          <label for="birthdate" class="label">Data de Nascimento</label>
          <input
            type="text"
            id="birthdate"
            name="birthdate"
            class="form-control"
            v-model="form.birthdate"
            v-mask="'##/##/####'"
            autocomplete
            required
          >
          <p class="description" v-if="errors.form.birthdate.length > 0">{{ errors.form.birthdate[0] }}</p>
        </div>
      </div>
    </div>

    <div class="form-group" :class="{'-has-error': errors.form.zip.length > 0, '-has-error': errors.form.zip.length > 0}">
      <label for="zip" class="label">CEP</label>
      <input
        type="text"
        id="zip"
        name="zip"
        class="form-control"
        v-model="form.zip"
        v-mask="'##.###-###'"
        autocomplete
        required
        @keyup="$event.target.value.length === 10 ? findAddressByZip($event.target.value) : null"
      >
      <p class="description" v-if="errors.form.zip.length > 0">{{ errors.form.zip[0] }}</p>
    </div>

    <div class="form-group" :class="{ '-loading': zipLoading, '-has-error': errors.form.street.length > 0 }">
      <label for="street" class="label">Endereço</label>
      <input
        type="text"
        id="street"
        name="street"
        class="form-control"
        v-model="form.street"
        :disabled="zipLoading"
        autocomplete
        required
      >
      <p class="description" v-if="errors.form.street.length > 0">{{ errors.form.street[0] }}</p>
    </div>

    <div class="flex flex-wrap md:flex-no-wrap md:gap-4">
      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{ '-loading': zipLoading, '-has-error': errors.form.number.length > 0 }">
          <label for="number" class="label">Número</label>
          <input
            type="text"
            id="number"
            name="number"
            class="form-control"
            v-model="form.number"
            :disabled="zipLoading"
            autocomplete
            required
          >
          <p class="description" v-if="errors.form.number.length > 0">{{ errors.form.number[0] }}</p>
        </div>
      </div>

      <div class="w-full md:w-1/2">
        <div class="form-group" :class="{ '-loading': zipLoading, '-has-error': errors.form.complement.length > 0 }">
          <label for="complement" class="label">Complemento</label>
          <input
            type="text"
            id="complement"
            name="complement"
            class="form-control"
            v-model="form.complement"
            :disabled="zipLoading"
            autocomplete
          >
          <p class="description" v-if="errors.form.complement.length > 0">{{ errors.form.complement[0] }}</p>
        </div>
      </div>
    </div>

    <div class="form-group" :class="{ '-loading': zipLoading, '-has-error': errors.form.district.length > 0 }">
      <label for="district" class="label" >Bairro</label>
      <input
        type="text"
        id="district"
        name="district"
        class="form-control"
        v-model="form.district"
        :disabled="zipLoading"
        autocomplete
        required
      >
      <p class="description" v-if="errors.form.district.length > 0">{{ errors.form.district[0] }}</p>
    </div>

    <div class="flex flex-wrap md:flex-no-wrap md:gap-4">
      <div class="w-full md:w-2/3">
        <div class="form-group" :class="{ '-loading': zipLoading, '-has-error': errors.form.city.length > 0 }">
          <label for="city" class="label">Cidade</label>
          <input
            type="text"
            id="city"
            name="city"
            class="form-control"
            v-model="form.city"
            :disabled="zipLoading"
            autocomplete
            required
          >
          <p class="description" v-if="errors.form.city.length > 0">{{ errors.form.city[0] }}</p>
        </div>
      </div>

      <div class="w-full md:w-1/3">
        <div class="form-group" :class="{ '-loading': zipLoading, '-has-error': errors.form.state.length > 0 }">
          <label for="state" class="label">Estado</label>
          <select
            name="state"
            id="state"
            class="form-control"
            v-model="form.state"
            :disabled="zipLoading"
            required
          >
            <option value="AC">Acre</option>
            <option value="AL">Alagoas</option>
            <option value="AP">Amapá</option>
            <option value="AM">Amazonas</option>
            <option value="BA">Bahia</option>
            <option value="CE">Ceará</option>
            <option value="DF">Distrito Federal</option>
            <option value="ES">Espírito Santo</option>
            <option value="GO">Goiás</option>
            <option value="MA">Maranhão</option>
            <option value="MT">Mato Grosso</option>
            <option value="MS">Mato Grosso do Sul</option>
            <option value="MG">Minas Gerais</option>
            <option value="PA">Pará</option>
            <option value="PB">Paraíba</option>
            <option value="PR">Paraná</option>
            <option value="PE">Pernambuco</option>
            <option value="PI">Piauí</option>
            <option value="RJ">Rio de Janeiro</option>
            <option value="RN">Rio Grande do Norte</option>
            <option value="RS">Rio Grande do Sul</option>
            <option value="RO">Rondônia</option>
            <option value="RR">Roraima</option>
            <option value="SC">Santa Catarina</option>
            <option value="SP">São Paulo</option>
            <option value="SE">Sergipe</option>
            <option value="TO">Tocantins</option>
            <option value="EX">Estrangeiro</option>
          </select>
          <p class="description" v-if="errors.form.state.length > 0">{{ errors.form.state[0] }}</p>
        </div>
      </div>
    </div>

    <div class="flex">
      <button class="btn btn-primary ml-auto" type="submit">Salvar</button>
    </div>

    <loader v-if="loading"/>
  </form>
</template>

<script>
import { mask } from 'vue-the-mask';
import { debounce } from 'lodash';
import dateFormat from '@/support/filters/dateFormat';
import Loader from '@/support/components/Loader.vue';
import checkErrorIsUnrecognizedResponse from '@/support/helpers/checkErrorIsUnrecognizedResponse';

export default {
  name: 'PersonalInformation',

  data() {
    const { user } = this.$store.state.auth;

    return {
      loading: false,
      zipLoading: false,
      finished: false,
      form: {
        email: user.email,
        name: user.name,
        cpf: user.cpf,
        phone: user.phone,
        street: user.street,
        number: user.number,
        complement: user.complement,
        district: user.district,
        city: user.city,
        state: user.state,
        zip: user.zip,
        birthdate: user.birthdate ? dateFormat(user.birthdate, 'DD/MM/YYYY') : null,
      },
      errors: {
        unrecognized: false,
        form: {
          email: [],
          name: [],
          cpf: [],
          phone: [],
          street: [],
          number: [],
          complement: [],
          district: [],
          city: [],
          state: [],
          zip: [],
          birthdate: [],
        },
      },
    };
  },

  methods: {
    /**
     * Find the address by zip.
     */
    findAddressByZip: debounce(
      async function findAddressByZip(zip) {
        try {
          this.zipLoading = true;

          const zipUnmasked = zip.replace(/\.|-/g, '');
          const address = await this.$store.dispatch('support/findAddressByZip', { zip: zipUnmasked });

          this.form.street = address.street;
          this.form.number = address.number;
          this.form.complement = address.complement;
          this.form.district = address.district;
          this.form.city = address.city;
          this.form.state = address.state;
        } finally {
          this.zipLoading = false;
        }
      },
      500,
    ),

    /**
     * Update the personal information.
     *
     * @returns {Promise<void>}
     */
    async update() {
      try {
        this.finished = false;
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/updatePersonalInformation', this.form);
        await this.$store.dispatch('auth/loadUser');

        this.finished = true;
      } catch (err) {
        if (checkErrorIsUnrecognizedResponse(err, [422])) {
          this.errors.unrecognized = true;
          return;
        }

        const { data, status } = err.response;

        if (status === 422) {
          this.errors.form.email = data.errors.email || [];
          this.errors.form.name = data.errors.name || [];
          this.errors.form.cpf = data.errors.cpf || [];
          this.errors.form.phone = data.errors.phone || [];
          this.errors.form.street = data.errors.street || [];
          this.errors.form.number = data.errors.number || [];
          this.errors.form.complement = data.errors.complement || [];
          this.errors.form.district = data.errors.district || [];
          this.errors.form.city = data.errors.city || [];
          this.errors.form.state = data.errors.state || [];
          this.errors.form.zip = data.errors.zip || [];
          this.errors.form.birthdate = data.errors.birthdate || [];
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.form.email = [];
      this.errors.form.name = [];
      this.errors.form.cpf = [];
      this.errors.form.phone = [];
      this.errors.form.street = [];
      this.errors.form.number = [];
      this.errors.form.complement = [];
      this.errors.form.district = [];
      this.errors.form.city = [];
      this.errors.form.state = [];
      this.errors.form.zip = [];
      this.errors.form.birthdate = [];
      this.errors.unrecognized = false;
    },
  },

  directives: {
    mask,
  },

  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>

</style>
